import React from 'react';
import { Route } from 'react-router-dom';
import { STATUS_OK, STATUS_NOT_FOUND, STATUS_SERVER_ERROR } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";

const Status = ({
  children,
  status
}) => /*#__PURE__*/_jsx(Route, {
  render: ({
    staticContext
  }) => {
    if (staticContext) {
      staticContext.status = status;
    }

    return children;
  }
});

export default Status;